// extracted by mini-css-extract-plugin
export var dot = "styles-module--dot--73baa";
export var dots = "styles-module--dots--a53c9";
export var preparing = "styles-module--preparing--2ce64";